import track, { useTracking } from 'react-tracking';

import PNV from '@/components/PositiveNegativeValue';

import { useRecentlyViewedCompanies } from './hooks/useRecentlyViewedCompanies';

import DataTable, { SubTable, CellLink } from '../DataTable';
import RecentlyViewedSkeleton from './RecentlyViewedSkeleton';
import { TickerSymbol, Name, SharePrice, NoData, Detail } from './styled';

const RecentlyViewed = () => {
  const { trackEvent } = useTracking();
  const { data = { keys: [], entities: {} }, isFetching } =
    useRecentlyViewedCompanies();

  const { keys, entities } = data;

  return isFetching ? (
    <RecentlyViewedSkeleton />
  ) : (
    <DataTable
      columnWidths="4, 2, 2"
      columnTextAlignments="l,r,r"
      data-cy-id="dashboard-recently-viewed-table"
    >
      <thead>
        <tr>
          <th>Symbol</th>
          <th>7D</th>
          <th>1Y</th>
        </tr>
      </thead>
      <tbody>
        {keys.length === 0 ? (
          <tr>
            <td colSpan={3}>
              <NoData>You haven't viewed any companies yet</NoData>
            </td>
          </tr>
        ) : (
          keys.map((n, i) => (
            <tr
              key={`recently-viewed-item-${entities[n].name}-${n}`}
              data-cy-id="dashboard-recently-viewed-item"
            >
              <td colSpan={3}>
                <SubTable>
                  <tbody>
                    <tr>
                      <Detail>
                        <CellLink
                          to={entities[n].canonicalUrl}
                          onClick={() =>
                            trackEvent({
                              action: 'click',
                              modifier: 'list_item',
                              companyId: n,
                              uniqueSymbol: entities[n].uniqueSymbol,
                              index: i,
                            })
                          }
                        >
                          <TickerSymbol data-cy-id="dashboard-recently-viewed-ticker">
                            {`${entities[n].tickerSymbol} `}
                          </TickerSymbol>
                          <SharePrice data-cy-id="dashboard-recently-viewed-share-price">
                            {entities[n].sharePriceFormatted}
                          </SharePrice>
                        </CellLink>
                      </Detail>
                      <PNV
                        as="td"
                        value={entities[n].return7D}
                        data-cy-id="dashboard-recently-viewed-return7D"
                      >
                        <CellLink
                          to={entities[n].canonicalUrl}
                          onClick={() =>
                            trackEvent({
                              action: 'click',
                              modifier: 'list_item',
                              companyId: n,
                              uniqueSymbol: entities[n].uniqueSymbol,
                              index: i,
                            })
                          }
                        >
                          {entities[n].return7DFormatted}
                        </CellLink>
                      </PNV>
                      <PNV
                        as="td"
                        value={entities[n].return1YrAbs}
                        data-cy-id="dashboard-recently-viewed-return1Y"
                      >
                        <CellLink
                          to={entities[n].canonicalUrl}
                          onClick={() =>
                            trackEvent({
                              action: 'click',
                              modifier: 'list_item',
                              companyId: n,
                              uniqueSymbol: entities[n].uniqueSymbol,
                              index: i,
                            })
                          }
                        >
                          {entities[n].return1YrAbsFormatted}
                        </CellLink>
                      </PNV>
                    </tr>
                    <tr>
                      <Name
                        colSpan={3}
                        data-cy-id="dashboard-recently-viewed-name"
                      >
                        <CellLink
                          to={entities[n].canonicalUrl}
                          onClick={() =>
                            trackEvent({
                              action: 'click',
                              modifier: 'list_item',
                              companyId: n,
                              uniqueSymbol: entities[n].uniqueSymbol,
                              index: i,
                            })
                          }
                        >
                          <span>{entities[n].name}</span>
                        </CellLink>
                      </Name>
                    </tr>
                  </tbody>
                </SubTable>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </DataTable>
  );
};

export default track({
  type: 'track',
  subject: 'recently_viewed_module',
})(RecentlyViewed);
